module.exports = __webpack_public_path__ + "img/chip.52832124.png";